import { useEnableShippySierraChatIntegration } from '../../../feature-flags/hooks/use-enable-shippy-sierra-chat-integration';
import { useShouldShowShippyButton } from './use-should-show-shippy-button';

export const useShouldRouteToShippy = (): boolean => {
  const shouldShowShippyButton = useShouldShowShippyButton();
  const isShippySierraIntegrationEnabled = useEnableShippySierraChatIntegration();

  return shouldShowShippyButton && isShippySierraIntegrationEnabled;
};
